module.exports = __webpack_public_path__ + "static/preview-overlay-video-b7fcf5c2e1508f690d0ff0a2fa2a035d.jpg";